<!-- 收获地址确认弹窗 -->
<template>
  <div class="address-popup">
    <van-overlay
      :show="show"
      :lock-scroll="false"
      class="my-overlay"
      z-index="999"
    >
      <div class="wrapper" @click.stop>
        <div class="title">确认收货地址</div>
        <van-form @submit="onSubmit">
          <van-cell-group inset>
            <van-field
              v-model="formData.receiverName"
              label="收货人"
              placeholder="填写收货人姓名"
              size="small"
              label-width="70px"
              maxlength="20"
              :rules="[{ required: true, message: '请写收货人姓名' }]"
            />
            <van-field
              v-model="formData.receiverPhone"
              label="联系方式"
              placeholder="填写收货人手机号"
              size="small"
              label-width="70px"
              maxlength="11"
              :rules="[
                { validator: validatorPhone, message: '请填写正确的手机号' },
              ]"
            />
            <van-field
              v-model="formData.receiveArea"
              is-link
              readonly
              label="所在地区"
              placeholder="省市区乡镇等"
              @click="regionShow = true"
              label-width="70px"
              :rules="[{ required: true, message: '请选择所在地区' }]"
            />
            <van-field
              v-model="formData.detailAddress"
              label="详细地址"
              placeholder="街道,楼牌号等"
              size="small"
              label-width="70px"
              maxlength="30"
              :rules="[{ required: true, message: '请填写详细地址' }]"
            />
          </van-cell-group>
          <div style="margin: 16px">
            <van-button
              round
              block
              type="primary"
              native-type="submit"
              color="#000000"
              :loading="btnLoading"
            >
              去支付
            </van-button>
          </div>
        </van-form>
      </div>
      <van-icon name="close" class="close-icon" @click="close" />
    </van-overlay>
    <van-popup v-model:show="regionShow" round position="bottom">
      <van-cascader
        v-model="cascaderValue"
        title="请选择所在地区"
        :options="options"
        @close="regionShow = false"
        @finish="onFinish"
      />
    </van-popup>
  </div>
</template>
<script>
import { hjUserReceiverInfoListApi, hjUserReceiverInfoAddApi, hjUserReceiverInfoUpdateApi, } from '@/api/huijuinterface.js'
import placesData from '@/utils/places'
export default {
  props: [],
  data() {
    return {
      show: false,
      regionShow: false,
      options: [],
      formData: {
        receiverName: '', // 联系人
        receiverPhone: '', // 联系方式
        receiveArea: '', // 地区-省市区拼接
        province: '',
        provinceCode: '',
        city: '',
        cityCode: '',
        area: '',
        areaCode: '',
        detailAddress: '', // 详细地址

        // "receiverName": "刘", "receiverPhone": "15160165871", "receiveArea": "福建省/厦门市/思明区", "province": "福建", "provinceCode": "福建", "city": "厦门", "cityCode": "厦门", "area": "思明区", "areaCode": "思明区", "detailAddress": "观音山"
      },
      cascaderValue: '', // 取地区的最后一项，就可以保证cascader组件默认选中
      btnLoading: false,
    }
  },
  created() {
    // 地区数据格式化
    const placesData1 = this.formMateArea(placesData)
    this.options = placesData1
  },
  methods: {

    close() {
      this.show = false
    },
    open() {
      this.show = true
      this.getAddress()
    },
    setShow(val) {
      this.show = val
    },
    // 获取地址
    getAddress() {
      hjUserReceiverInfoListApi({}).then(res => {
        if (res.data.length) {
          const { province, city, area } = res.data[0]
          this.formData = {
            ...this.formData,
            ...res.data[0],
            receiveArea: `${province}/${city}${area ? '/' : ''}${area}`
          }
          this.cascaderValue = area ? area : city
        }
      })
    },
    // 地址提交成功
    handleSuccess(data) {
      this.btnLoading = false
      this.$emit('addressConform', data)
      this.close()
    },
    add(data) {
      hjUserReceiverInfoAddApi({
        ...data,
        userDefault: 1,
      }).then(res => {
        this.handleSuccess(data)
      }).catch(() => {
        this.btnLoading = false
      })
    },
    update(data) {
      hjUserReceiverInfoUpdateApi({
        ...data,
      }).then(res => {
        this.handleSuccess(data)
      }).catch(() => {
        this.btnLoading = false
      })
    },
    onSubmit(values) {
      const data = JSON.parse(JSON.stringify(this.formData))
      this.btnLoading = true
      if (data.id) {
        this.update(data)
      } else {
        this.add(data)
      }
    },
    // 校验函数返回 true 表示校验通过，false 表示不通过
    validatorPhone(val) {
      return /1\d{10}/.test(val);
    },
    // 选择地区,需要自己加上省，市，但是北京，上海，天津等只需要加市
    onFinish({ selectedOptions }) {
      // console.log(selectedOptions, ' selectedOptions');
      this.regionShow = false

      this.formData.area = ''
      this.formData.areaCode = ''

      const length = selectedOptions.length
      this.formData.receiveArea = selectedOptions
        .map((option, index) => {
          let text = option.text
          if (length === 3) {
            if (index === 0) text = option.text + '省'
            if (index === 1) text = option.text + '市'
          }
          if (length === 2 && index === 0) {
            text = option.text + '市'
          }
          switch (index) {
            case 0:
              this.formData.province = text
              this.formData.provinceCode = text
              break;
            case 1:
              this.formData.city = text
              this.formData.cityCode = text
              break;
            case 2:
              this.formData.area = text
              this.formData.areaCode = text
              break;
          }
          return text
        })
        .join('/')

    },
    // 地区数据格式化
    formMateArea(data) {
      const res = []
      data.map(i => {
        const obj = {
          text: i.name || i,
          value: i.name || i
        }
        if (i.sub && this.isObject(i)) {
          obj.children = this.formMateArea(i.sub)
        }
        res.push(obj)
      })
      return res
    },
    //判断是否是对象
    isObject(obj) {
      return Object.prototype.toString.call(obj) == '[object Object]'
    },
    // 截取地址最后一项，设置为cascaderValue的值
    setCascaderValue() {
      const arr = this.formData.receiveArea.split('/')
      const length = arr.length
      this.cascaderValue = arr[length - 1]
    },
  },

}
</script>
<style lang="less" scoped>
.address-popup {
  position: relative;
  .my-overlay {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .wrapper {
    margin: 0 auto;
    padding: 10px 20px 10px 20px;
    width: 350px;
    box-sizing: border-box;
    background: #fff;
    border-radius: 10px;
    position: relative;

    .title {
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      padding: 20px 0 20px 0;
    }
  }
  .close-icon {
    font-size: 30px;
    color: #fff;
    margin: 20px auto;
  }
}
</style>
